<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="month" placeholder="选择月" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border 
          height="100%" style="width: 100%">
          <el-table-column align="center" label="人员" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="工种" min-width="100" prop="zhiwei"></el-table-column>
          <el-table-column align="center" v-for="(item,index) in listObj" :key="index"
            :label="item" min-width="100" :prop="item"></el-table-column>
          <el-table-column align="center" label="合计" min-width="100" prop="heji"></el-table-column>
        </el-table>
      </div>
    </div>

    
  </div>
</template>

<script>
  import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      listObj: {},
      sf: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    cellClick(row, column) {
      console.log(row, column)
      if(column.label == '人员'||column.label == '合计') {
        console.log('非日期')
        return
      }
      if(row[column.label]==0) {
        this.$message.warning('当日无工作')
        return
      }
      let day = this.today.getFullYear()+'-'+column.label
      // row.renyuan
      this.$router.push('/fengrengongziDetail?day='+day+'&renyuan='+row.renyuan)
    },
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      axios.post(this.$host+'/index.php/admin/Yuegongziexcel/yuebaozhuangExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '包装月工资汇总';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      this.$request.post('/index.php/admin/Yuegongzi/yuebaozhuang', data).then((res) => {
        this.list = res.data.data
        this.listObj = res.data.listObj
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
